import { InternationalSummaryPage } from "@nju/feature-portal-additional-packages";
import { RequiredDashboardData } from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../../../components/ClientSideRenderer";

export default function InternationalSummary() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent>
        <ClientSideOnly>
          <RequiredDashboardData extendedMode="mobile">
            <InternationalSummaryPage />
          </RequiredDashboardData>
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
